import { defineMessages } from 'react-intl.macro';

export default defineMessages({
  header: {
    id: 'views.CSR.header',
    defaultMessage: 'chciałbyś zgłosić inicjatywę lub pomysł na nową grupę?'
  },
  buttonText: {
    id: 'views.CSR.buttonText',
    defaultMessage: 'skontaktuj się z nami!'
  },
  taxonomyAll: {
    id: 'views.CSR.filter.all',
    defaultMessage: 'Wszystkie'
  },
  taxonomyIT: {
    id: 'views.CSR.filter.it',
    defaultMessage: 'Lokalne środowisko IT'
  },
  taxonomyOther: {
    id: 'views.CSR.filter.other',
    defaultMessage: 'Otoczenie'
  },
  nothingWasFound: {
    id: 'views.CSR.nothingWasFound',
    defaultMessage: 'Nic nie znaleziono'
  }
});



// WEBPACK FOOTER //
// ./src/views/CSR/CSRView.intl.js